export default "__VITE_ASSET__CtR5D8Y1__"